/** localStorage session readers + spent-refresh-token registry for api.ts refresh. */

type StoredAuth = { accessToken?: string; refreshToken?: string };

function readStored(): StoredAuth | null {
  try {
    const stored = localStorage.getItem('maestro_auth');
    return stored ? (JSON.parse(stored) as StoredAuth) : null;
  } catch {
    return null;
  }
}

export function getToken(): string | null {
  return readStored()?.accessToken || null;
}

export function getRefreshToken(): string | null {
  return readStored()?.refreshToken || null;
}

export function readStoredAuthTokens(): { accessToken: string | null; refreshToken: string | null } {
  const parsed = readStored();
  return {
    accessToken: parsed?.accessToken || null,
    refreshToken: parsed?.refreshToken || null,
  };
}

/**
 * Refresh-token fingerprints that came back "Already Used" (single-use rotation lost).
 * Never POST these again — a second spend revokes the whole family (#602).
 */
const spentRefreshFps = new Set<string>();

export function markRefreshFpSpent(fp: string): void {
  spentRefreshFps.add(fp);
}

export function isRefreshFpSpent(fp: string): boolean {
  return spentRefreshFps.has(fp);
}

export function clearSpentRefreshFps(): void {
  spentRefreshFps.clear();
}
